import React from 'react';

import ResultList from './result-list';
import ResultBreakdown from './result-breakdown';
import ServerPaginatedTable from '../utils/pagination.server';
import {
    Card, CardBody, CardGroup
} from 'reactstrap';
import IconDollar from 'react-icons/lib/fa/dollar';
import IconAirlineSeat from 'react-icons/lib/md/airline-seat-recline-normal';
import IconMdDate from 'react-icons/lib/md/date-range';

import { appHelpers } from '../../_helpers';
import moment from 'moment';

const SearchResult = ({data, showManifest, handleAirlineBD, handleDepBD, handleDesBD, handleRouteBD, airports}) => {
    return (
        <ResultList manifests={data.Manifests.Items} showManifest={showManifest} />
    )
};


export default class PaginatedResult extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            TSCAmount: this.props.manifestResults.TSCAmount.Items,
        }
    }

    componentWillReceiveProps(nextProps, nextState) {
        if(!appHelpers.isEqual(nextProps.manifestResults.TSCAmount.Items, this.state.TSCAmount)) {
            this.setState({ TSCAmount: nextProps.manifestResults.TSCAmount.Items})
        }
    }

    getTSCNaira = () => {
        const { TSCAmount } = this.state;
        let TSCNaira = TSCAmount.filter(tsc => tsc.Name === "566")[0];
        if (TSCNaira) {
            return appHelpers.numberWithCommas(TSCNaira.ItemValue);
        }
        return 0;
    }

    getTSCDollar = () => {
        const { TSCAmount } = this.state;
        let TSCDollar = TSCAmount.filter(tsc => tsc.Name === "840")[0];
        if (TSCDollar) {
            return appHelpers.numberWithCommas(TSCDollar.ItemValue);
        }
        return 0;
    }

    render() {
        const { pageSize, currentPage, totalCount, navigate, manifestResults, showManifest, handleAirlineBD, handleDepBD, handleDesBD, handleRouteBD, airports } = this.props;
        return (
            <div>
                <CardGroup className="sales-card mb-4">
                    <Card style={{'flex': '1.5 0 0'}}>
                        <CardBody  className="justify-content-between fit">
                            <h6 className="text-uppercase title font-weight-bold small">Total TSC</h6>
                            <h4 className="font-weight-normal mb-0"><span style={{ color: "#00c853", size: "20px"}}>&#8358;</span> {this.getTSCNaira()} &nbsp;|&nbsp;<IconDollar size="16" color="#00c853"/>{this.getTSCDollar()}</h4>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardBody className={'fit'}>
                            <h6 className="text-uppercase title font-weight-bold small">Total Passengers</h6>
                            <h4 className="font-weight-normal mb-0"><IconAirlineSeat size="20" color="#0a3150"/>{appHelpers.numberWithCommasOnly(manifestResults.PassengerCount.ItemValue)}</h4>
                        </CardBody>
                    </Card>
                    <Card style={{'flex': '1.5 0 0'}}>
                        <CardBody className={'fit'}>
                            <h6 className="text-uppercase title font-weight-bold small">First & Last Flight</h6>
                            <h4 className="font-weight-normal mb-0"><IconMdDate size="20" color="#202021"/>{moment((manifestResults.DepatureDR.Items[0].ItemValue).split('T')[0]).format('MMM Do YYYY')} || {moment((manifestResults.DepatureDR.Items[1].ItemValue).split('T')[0]).format('MMM Do YYYY')}</h4>
                        </CardBody>
                    </Card>
                </CardGroup>
                <div className="row">
                    <div className="col-md-8 col-sm-12 mb-4">
                        <ServerPaginatedTable currentPage={currentPage} fetchMore={navigate} target={<SearchResult data={manifestResults} showManifest={showManifest} />} pageSize={pageSize} totalCount={ totalCount }/>
                    </div>
                    <div className="col-md-4 col-sm-12 mb-4">
                        {airports && <ResultBreakdown resultBD={manifestResults} handleAirlineBD={handleAirlineBD} handleDepBD={handleDepBD} handleDesBD={handleDesBD} handleRouteBD={handleRouteBD} airports={airports} />}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/search/search-result.js